module.exports = function () {
    const tableOfContents = document.querySelector(".table-of-contents");
    const content = document.querySelector(".table-of-contents__content");
    const fcTitles = document.querySelectorAll("[data-fc-title]");
    if ( !tableOfContents ) return;

    const openButton = tableOfContents.querySelector(".table-of-contents__button");
    const closeButton = tableOfContents.querySelector(".table-of-contents__wrapper > button");

    openButton.addEventListener("click", () => tableOfContents.classList.add("open"));
    closeButton.addEventListener("click", () => tableOfContents.classList.remove("open"));

    const indicator = document.createElement("span");
    indicator.classList.add("table-of-contents__indicator");
    content.appendChild(indicator);

    let currentSection = null;

    // render list
    for (const title of fcTitles) {
        const li = document.createElement("li");
        li.innerHTML = `<a href="#${title.id}">${title.dataset.fcTitle}</a>`;
        content.appendChild(li);
    }

    function getCurrentSection() {
        let active = null;

        for (const title of fcTitles) {
            if ( !title.offsetParent ) continue;
            if ( title.getBoundingClientRect().top - window.innerHeight / 2 < 0 ) {
                active = title.id;
            }
        }

        return active;
    }

    function setCurrentSection() {
        content.querySelectorAll("li").forEach(li => li.classList.remove("active"));
        const activeLi = content.querySelector(`a[href="#${currentSection}"]`)?.parentElement;
        if ( !activeLi ) return;
        activeLi.classList.add("active");
        indicator.style.top = activeLi.offsetTop + "px";
        indicator.style.height = activeLi.offsetHeight + "px";
    }

    function updateCurrentSection() {
        const last = currentSection;
        currentSection = getCurrentSection();
        if ( last === currentSection ) return;
        setCurrentSection();
    }

    const header = document.querySelector(".header");

    function scrollToTarget(target) {
        const offsetTop = target.getBoundingClientRect().top + window.scrollY;
        const navHeight = header ? header.getBoundingClientRect().height : 0;
        scrollTo({ top: offsetTop - navHeight, behavior: "smooth" });
    }

    content.addEventListener("click", (e) => {
        const link = e.target.closest("a");
        if ( !link ) return;

        const id = link.getAttribute("href").slice(1);
        const target = document.getElementById(id);
        if ( !target ) return;

        e.preventDefault();

        const tabContent = target.closest("[data-tab-content]");
        if ( tabContent && tabContent.classList.contains("hidden") ) {
            const flexibleContent = tabContent.closest(".flexible-content");
            if ( !flexibleContent ) return;

            const tabContents = flexibleContent.querySelectorAll("[data-tab-content]");
            const swipe = flexibleContent.querySelector(".flexible-content__tab-buttons__swipe");
            const bannerPictures = flexibleContent.querySelectorAll(".pb-\\[50\\%\\] > picture");
            const tabIndex = Array.from(tabContents).indexOf(tabContent);

            if ( tabIndex === 0 ) {
                swipe.style.transform = `translateX(0px)`;
                tabContents[0].classList.remove("hidden");
                tabContents[1].classList.add("hidden");
            } else {
                swipe.style.transform = `translateX(calc(100% - 8px))`;
                tabContents[0].classList.add("hidden");
                tabContents[1].classList.remove("hidden");
            }

            bannerPictures.forEach((picture, i) => picture.classList.toggle("hidden", i !== tabIndex));

            requestAnimationFrame(() => scrollToTarget(target));
        } else {
            scrollToTarget(target);
        }
    });

    window.addEventListener("load", () => updateCurrentSection());
    window.addEventListener("scroll", updateCurrentSection);
}
